@switch (column.type) {
  @case (columnTypes.String) {
    <div class="cell-value text-ellipsis">{{ item[column.name] }}</div>
  }
  @case (columnTypes.Number) {
    <div class="cell-value text-ellipsis">
      {{ item[column.name] }}
    </div>
  }
  @case (columnTypes.Boolean) {
    <div class="cell-value text-ellipsis">
      {{ item[column.name] ? column['trueValue'] : column['falseValue'] }}
    </div>
  }
  @case (4) {
    <div class="cell-value text-ellipsis">{{ item[column.name] | dateFormat }}</div>
  }
  @case (5) {
    <div class="cell-value text-ellipsis">{{ item[column.name] | dateTimeFormat }}</div>
  }
  @case (6) {
    <div class="cell-value text-ellipsis">{{ column['enumData'][item[column.name]] }}</div>
  }
  @case (7) {
    <ng-template
      [ngTemplateOutlet]="column['template']"
      [ngTemplateOutletContext]="{ item: item, highlight: highlight }"
    ></ng-template>
  }
}
